import React, {Component} from 'react';
import {connect} from "react-redux";
import {addSubField} from "../../../../../store/actions/subFields";
import {FieldGroupContext} from "../../../../../contexts/FieldGroupContext";
import ParametersNotice from "../../Parameters/ParametersNotice";
import getFieldFactory from '../../Endpoint/FieldFactory';
import FieldGroups from '../FieldGroups';

class Output extends Component {

  state = {
    selectedFilterToAdd: ''
  };

  handleSelectedFilterToAdd = (e) => {
    this.setState({selectedFilterToAdd: e.target.value});
  };

	render() {

    let fields = [
      getFieldFactory().getNewDefaultFieldGroupForOutput( 'request_response', 'Request Response' ),
      {
        name:   'normal_field',
        label:  'Normal Field',
        fields: [
          {
            id:        'fieldName',
            inputType: 'input',
            value:     '',
            label:     'Field Name',
            dynamic:   false,
          },
          {
            id:        'fieldValue',
            inputType: 'input',
            value:     '',
            label:     'Field Value',
            dynamic:   false,
          },
        ],
      }
    ];

    fields = fields.map(field => {
      field.fields = [...field.fields, ...getFieldFactory().getExtraFields()];
      field.fields = field.fields.filter(field => field.id !== 'hideEmpty');

      return field;
    });

		const {addSubField, group} = this.props;

		return (
      <React.Fragment>
        <FieldGroupContext.Consumer>

          {({ endpointId, endpoint, currentItem, action }) => (<React.Fragment>
            <h3>Fields to display in the output: ({endpoint.displayData[currentItem].output.length})</h3>

            Select a field to output: <select value={this.state.selectedFilterToAdd} onChange={this.handleSelectedFilterToAdd}>
            <option value="">Select a field</option>
            {fields.sort((a, b) => (a.label > b.label) ? 1 : -1).map((el, index) => <option key={index} value={el.name}>{el.label}</option>)}
          </select>

            <button
              onClick={() => addSubField(endpointId, fields.filter(el => el.name === this.state.selectedFilterToAdd), currentItem, group, action)}
              disabled={!this.state.selectedFilterToAdd ? 'disabled' : ''}
              className="button-secondary"
            >
              Add field
            </button>

            <FieldGroups group={group} />

          </React.Fragment>)}
        </FieldGroupContext.Consumer>
      </React.Fragment>
		);
	}
}

const mapStateToProps = ( state ) => ( state );

const mapDispatchToProps = dispatch => ({
	addSubField: ( endpointId, field, currentItem, group, parentGroup ) => dispatch( addSubField( endpointId, field, currentItem, group, parentGroup ) ),
});

export default connect( mapStateToProps, mapDispatchToProps )(Output);
